import { getCmsSourceDomain } from '@fe/config'
import toast from '@r/page/src/utils/ui/toast'
import { getCurrentUser } from '@r/page/src/utils/user'
import { isMiniProgram, isSunriseClient } from '@r/skip/src/utils/browser'
import axios from 'axios'
import { commonModel } from '../model/index'
import { getH5SmDeviceId } from '@r/page/src/utils/smcaptcha'

export const postApplyCoupon = async (params: PARAMS.IApiGetCoupon, extParams: PassExtParamsDescriptorMore = { showLoading: false, showToast: true }) => {
  const userInfo = getCurrentUser()

  if (extParams.showToast) {
    toast.loading('')
  }

  const deviceId = await getH5SmDeviceId()

  const userParams = {
    userId: userInfo.userId,
    memberCode: userInfo.srCode || '',
    deviceId: deviceId || '',
  }

  return commonModel
    .apiPostGetUserCoupon<API_PostGetUserCoupon.IApiPostGetUserCoupon>({ ...params, ...extParams, ...userParams })
    .then((data) => {
      return data
    })
    .catch((e) => {
      throw e
    })
    .finally(() => {
      setTimeout(toast.onClose, 500)
    })
}

export const getGoodsDetail = async (params, extParams: PassExtParamsDescriptorMore = { showLoading: false, showToast: true }) => {
  return commonModel.apiPostGetGoodsDetail<API_PostGetGoodsDetail.IApiPostGetGoodsDetail>({ ...params, ...extParams }).catch((e) => {
    console.error(e)
    throw e
  })
}

export const getGoodsDetailv2 = async (params, extParams: PassExtParamsDescriptorMore = { showLoading: false, showToast: true }) => {
  return commonModel.apiPostGetGoodsDetailv2<API_PostGetGoodsDetail.IApiPostGetGoodsDetail>({ ...params, ...extParams }).catch((e) => {
    console.error(e)
    throw e
  })
}
export const getGoodsDetailv3 = async (params, extParams: PassExtParamsDescriptorMore = { showLoading: false, showToast: true }) => {
  return commonModel.apiPostGetGoodsDetailv3<API_PostGetGoodsDetail.IApiPostGetGoodsDetail>({ ...params, ...extParams }).catch((e) => {
    console.error(e)
    throw e
  })
}
export const postSearchList = async (params, extParams: PassExtParamsDescriptorMore = { showLoading: false, showToast: true }) => {
  return commonModel.apiPostSearchList<API_PostSearchList.IApiPostSearchList>({ ...params, ...extParams }).catch((e) => {
    console.error(e)
    throw e
  })
}
export const getCouponsList = async (params, extParams: PassExtParamsDescriptorMore = { showLoading: false, showToast: true }) => {
  const tokenInfo = getCurrentUser()

  const userParams = {
    userId: tokenInfo.userId,
    memberCode: tokenInfo.srCode || '',
    channel: isSunriseClient || isMiniProgram ? 1 : 2,
  }

  return commonModel.apiPostGetCouponsList<API_PostGetCouponsList.IApiPostGetCouponsList>({ ...params, ...extParams, ...userParams }).catch((e) => {
    console.error(e)
    throw e
  })
}
export const getStaticSource = async (params: PARAMS.IApiGetStaticSource, extParams: PassExtParamsDescriptorMore = { showLoading: false, showToast: true }) => {
  return commonModel.apiGetStaticSource<API_GetStaticSource.IApiGetStaticSource>({ ...params, ...extParams }).catch((e) => {
    console.error(e)
    throw e
  })
}

export const getServeTimeNow = async () => {
  return commonModel.apiPostTimeNow<API_PostTimeNow.IApiPostTimeNow>().catch((e) => {
    console.error(e)
    throw e
  })
}

export const getTags = async () => {
  return commonModel.apiPostUserTag<API_PostUserTag.IApiPostUserTag>().catch((e) => {
    console.log(e)
    throw e
  })
}

export const getStaticSourceByUrl: <T>(params: PARAMS.IApiGetStaticSource, extParams?: PassExtParamsDescriptorMore) => Promise<T> = async (params, extParams = { showLoading: false, showToast: true }) => {
  const sourceUrl = `${getCmsSourceDomain()}/content/${params.id}.json?t=${params.updateTime}`

  return axios
    .get(sourceUrl)
    .then((response) => {
      if (response.status === 200) {
        return response.data
      }

      toast.error()
    })
    .finally(() => {})
}

export const getPageElements: (id: string, updateTime?: string) => Promise<API_GetSourceByUrl.IApiGetSouceByUrl> = async (id, updateTime) => {
  // 在home页面加载loading,获取系统当前时间的接口比较慢，在所有接口调用完之后再hide比较好
  // toast.loading()

  return getStaticSourceByUrl<API_GetSourceByUrl.IApiGetSouceByUrl>({ id, updateTime }).catch((e) => {
    throw e
  })
  // .finally(toast.hide)
}

export const getCMSid = async (params: PARAMS.IApiPostGetCMSid) => {
  return commonModel.apiPostGetCMSid<API_PostGetCMSid.IApiPostGetCMSid>({ ...params }).catch((e) => {
    console.log(e)
    throw e
  })
}

export const getPrizeInfo = async (params: PARAMS.IApiPostGetPrize) => {
  return commonModel.apiPostGetActivityInfo<API_PostGetPrize.IApiPostGetPrize>({ ...params }).catch((e) => {
    throw e
  })
}

export const GetQaActivityInfo = async (params: PARAMS.IApiPostGetQaActivityInfo) => {
  return commonModel.apiPostQaActivityInfo<API_PostGetQaActivityInfo.IApiPostGetQaActivityInfo>({ ...params }).catch((e) => {
    throw e
  })
}

export const SubmitQaAnswer = async (params: any) => {
  return commonModel.apiPostQaAddAnswer<API_PostGetQaActivityInfo.IApiPostQaAddAnswer>({ ...params, fullResponse: true }).catch((e) => {
    throw e
  })
}

export const applyPrize = async (params: PARAMS.IApiPostApplyPrize, extParams: PassExtParamsDescriptorMore = { fullResponse: true }) => {
  const userInfo = getCurrentUser()

  const userParams = {
    userId: userInfo.userId,
    memberCode: userInfo.srCode || '',
  }

  return commonModel.apiPostApplyPrize<API_PostApplyPrize.IApiPostApplyPrize>({ ...params, ...userParams, ...extParams }).catch((e) => {
    throw e
  })
}

export const reportShare = async (params: PARAMS.IApiPostShareAction) => {
  return commonModel.apiPostShareReport({ ...params }).catch((e) => {
    throw e
  })
}

export const getShareIdService = async (params: PARAMS.IApiPostShareId) => {
  return commonModel.apiPostGetShareId<API_PostGetShareId.IApiPostGetShareId>({ ...params }).catch((e) => {
    throw e
  })
}

export const getShareIconService = async (params: PARAMS.IApiGetShareIconConfig) => {
  return commonModel.apiPostGetShareEntryConfig<API_PostGetShareEntryConfig.IApiPostGetShareEntryConfig>({ ...params }).catch((e) => {
    throw e
  })
}

export const apiPostDrawShareFission = async (params: PARAMS.IApiPostDrawShareFission, extParams: PassExtParamsDescriptorMore = { fullResponse: true }) => {
  const userInfo = getCurrentUser()
  const userParams = {
    userId: userInfo.userId,
    memberCode: userInfo.srCode || '',
  }

  return commonModel
    .apiPostDrawShareFission<API_PostDrawShareFission.IApiPostDrawShareFission>({ ...params, ...extParams, ...userParams })
    .then((data) => {
      return data
    })
    .catch((e) => {
      throw e
    })
}

export const apiPostShareDrawHistory = async (params: PARAMS.IApiPostShareDrawHistory, extParams: PassExtParamsDescriptorMore = { fullResponse: true }) => {
  return commonModel.apiPostShareDrawHistory<API_PostShareDrawHistory.IApiPostShareDrawHistory>({ ...params, ...extParams }).catch((e) => {
    throw e
  })
}

export const apiPostGetVersion = async (extParams: PassExtParamsDescriptorMore) => {
  return commonModel.apiPostSearchVersion({ ...extParams }).catch((e) => {
    throw e
  })
}

export const getVoteList = async (params?, extParams: PassExtParamsDescriptorMore = { showLoading: false, showToast: true }) => {
  return commonModel.apiPostGetVoteList<API_PostGetVoteList.IApiPostGetVoteList>({ ...params, ...extParams }).catch((e) => {
    console.error(e)
    throw e
  })
}

export const addVote = async (
  params: {
    activityKey: string
    voteData: {
      cartoonId: string | number
      voteCnt: number
    }[]
  },
  extParams: PassExtParamsDescriptorMore = { showLoading: false, showToast: true }
) => {
  return commonModel.apiPostAddVote<API_PostAddVote.IApiPostAddVote>({ ...params, ...extParams }).catch((e) => {
    console.error(e)
    throw e
  })
}

export const getVideoData = async (params: API_GetVideo.IApiGetVideoRequest, extParams: PassExtParamsDescriptorMore = { fullResponse: true }): Promise<CMSVideo.IVideoData> => {
  const res = await commonModel.apiGetVideo<API_GetVideo.IApiGetVideoResponse>({ videoId: params.videoId, extParams })
  if (!res?.playInfoList?.length) {
    return Promise.reject(res)
  }
  const item = res.playInfoList.find((obj) => obj.status === 'Normal' && obj.format === 'mp4') || res.playInfoList[0]
  return {
    bitrate: item.bitrate || '',
    width: item.width || 0,
    height: item.height || 0,
    duration: item.duration || '',
    coverURL: params.coverURL || '',
    playURL: item.playURL || '',
  }
}

/**
 * @description 分享领券助力活动 获取活动信息
 */
export const GetShareActivityInfo = async (params: { activityId: string; sourceUserId?: string }, extParams: PassExtParamsDescriptorMore = { fullResponse: true }) => {
  return commonModel.apiPostGetShareInfo<API_PostGetHelpActivityInfo.IApiPostGetHelpActivityInfo>({ ...params, ...extParams }).catch((e) => {
    throw e
  })
}

/**
 * @description 分享领券助力活动 客态给主态助力
 */
export const HelpShareAssist = async (params: { activityKey: string; sourceUserId: string; shareId: string; eventType: 'fission_assistance'; shareCouponId: string }, extParams: PassExtParamsDescriptorMore = { fullResponse: true }) => {
  return commonModel.apiPostShareAssist<API_PostGetHelpActivityInfo.IApiPostHelpShareAssist>({ ...params, ...extParams }).catch((e) => {
    throw e
  })
}

/**
 * @description 分享领券助力活动 开启新一轮的活动
 */
export const CreateActivity = async (params: { activityKey: string; eventType: 'fission_share' }, extParams: PassExtParamsDescriptorMore = { fullResponse: true }) => {
  return commonModel.apiPostShareAssist<API_PostGetHelpActivityInfo.IApiPostHelpShareAssist>({ ...params, ...extParams }).catch((e) => {
    throw e
  })
}

/** apollo 前端开关配置 */
export const getApolloConfig = (
  params: {
    keys: string[]
  },
  extParams: PassExtParamsDescriptorMore = { showLoading: false, showToast: false }
) => {
  return commonModel
    .apiPostGetApolloConfig<{
      data: Record<string, any>
    }>({ ...params, ...extParams })
    .catch((e) => {
      console.error(e)
      throw e
    })
}

/**
 * @description 打call活动信息配置
 */
export const GetDanceList = async (params: { id: string }, extParams?: PassExtParamsDescriptorMore) => {
  return commonModel.apiPostGetDanceList<API_PostGetDanceList.IApiPostGetDanceList>({ ...params, ...extParams }).catch((e) => {
    throw e
  })
}

/**
 * @description 打call活动 增加投票
 */
export const DanceAdd = async (params: { activityKey: string; eventType: string }, extParams: PassExtParamsDescriptorMore = { fullResponse: true }) => {
  return commonModel.apiPostDanceAdd<API_PostDanceAdd.IApiPostDanceAdd>({ ...params, ...extParams }).catch((e) => {
    throw e
  })
}
